import debounce from 'lodash.debounce';

import Base from '../base';

const CHECK_TIMEOUT = 100;

class InputMatchesInput extends Base {
	start() {
		const { fieldSelector } = this.options;

		if (!fieldSelector) {
			console.warn('A field selector mandatory');

			return;
		}

		this.referenceField = this.query(fieldSelector, document.body);

		if (!this.referenceField) {
			console.warn(`Could not find an element for selector "${fieldSelector}"`);

			return;
		}


		this.checkValidity = debounce(this.checkValidity, CHECK_TIMEOUT);

		this.on('blur');
		this.on('input');

		this.on('blur', this.referenceField);
		this.on('input', this.referenceField);

		this.on('submit', this.el.form);
	}

	set isValid(valid) {
		this.el.classList.toggle('is-valid', valid);
		this.el.classList.toggle('is-invalid', !valid);
	}

	onBlur() {
		this.el.classList.add('is-changed');

		this.checkValidity();
	}

	onInput() {
		this.checkValidity();
	}

	onSubmit(e) {
		const isValid = this.checkValidity(this.el);

		if (!isValid) {
			e.preventDefault();
		}
	}

	checkValidity() {
		const referenceValue = this.referenceField.value;

		if (referenceValue === this.el.value) {
			this.el.setCustomValidity('');
		} else {
			this.el.setCustomValidity('The fields don\'t match');
		}

		const valid = this.el.checkValidity();

		this.isValid = valid;

		return valid;
	}
}

export default InputMatchesInput;
